var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyticSlant4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6842 53.3158H31.5578C31.0345 53.3158 30.6105 53.7398 30.6105 54.2632C30.6105 54.7865 31.0345 55.2105 31.5578 55.2105H31.6842C32.2075 55.2105 32.6315 54.7865 32.6315 54.2632C32.6315 53.7399 32.2075 53.3158 31.6842 53.3158Z",
    fill: "url(#paint0_linear_4127_28302)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8737 48.2631H15.1368C14.6135 48.2631 14.1895 48.6871 14.1895 49.2105C14.1895 49.7338 14.6136 50.1578 15.1368 50.1578H37.8737C38.397 50.1578 38.821 49.7338 38.821 49.2105C38.821 48.6872 38.397 48.2631 37.8737 48.2631Z",
    fill: "url(#paint1_linear_4127_28302)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7685 53.3158H15.1368C14.6135 53.3158 14.1895 53.7398 14.1895 54.2632C14.1895 54.7865 14.6136 55.2105 15.1368 55.2105H27.7684C28.2917 55.2105 28.7157 54.7865 28.7157 54.2632C28.7158 53.7399 28.2917 53.3158 27.7685 53.3158Z",
    fill: "url(#paint2_linear_4127_28302)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1579 18.5158C52.6345 18.5158 52.2105 18.9399 52.2105 19.4632V19.5895C52.2105 20.1129 52.6345 20.5368 53.1579 20.5368C53.6812 20.5368 54.1052 20.1129 54.1052 19.5895V19.4632C54.1053 18.9399 53.6812 18.5158 53.1579 18.5158Z",
    fill: "url(#paint3_linear_4127_28302)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14.7895H32.6315V14.4737C32.6315 12.5584 31.0732 11 29.1579 11H19.0527C17.1373 11 15.579 12.5584 15.579 14.4737V14.7895H14C10.6917 14.7895 8 17.4812 8 20.7895V58.6842C8 61.9925 10.6917 64.6842 14 64.6842H62C65.3083 64.6842 68 61.9925 68 58.6842V20.7895C68 17.4812 65.3083 14.7895 62 14.7895ZM9.89469 20.7895C9.89469 18.5258 11.7363 16.6842 14 16.6842H15.579V22.3684H9.89469V20.7895ZM66.1053 58.6843C66.1053 60.948 64.2637 62.7896 62 62.7896H14C11.7363 62.7896 9.89469 60.948 9.89469 58.6843V41.9475H39.7914L43.4053 51.183C43.803 52.2 44.7262 52.8883 45.8143 52.9796C46.9021 53.0718 47.9273 52.5461 48.4892 51.6097L51.7425 46.1875L57.1646 42.9342C57.5802 42.6848 57.9148 42.3443 58.1504 41.9473H66.1054L66.1053 58.6843ZM37.1067 35H17.7895C16.9188 35 16.2105 34.2917 16.2105 33.421V30.8947C16.2105 30.024 16.9188 29.3157 17.7895 29.3157H58.2105C59.0812 29.3157 59.7895 30.024 59.7895 30.8947V33.421C59.7895 34.2917 59.0812 35 58.2105 35H49.6736C49.613 35 49.5537 35.0057 49.4963 35.0165L40.9622 31.6771C40.6215 31.5439 40.2661 31.4792 39.9136 31.4792C39.1639 31.4792 38.4275 31.7724 37.8773 32.3225C37.1702 33.0297 36.8878 34.0443 37.1067 35ZM39.2172 33.6622C39.4936 33.3859 39.9075 33.2993 40.2716 33.4418L56.0477 39.615C56.3916 39.7495 56.6156 40.0497 56.6464 40.4178C56.6773 40.786 56.5067 41.1194 56.1898 41.3095L50.5646 44.6846C50.4314 44.7647 50.3197 44.8762 50.2397 45.0096L46.8645 50.6348C46.6745 50.9516 46.3393 51.123 45.973 51.0914C45.6048 51.0606 45.3045 50.8367 45.17 50.4925L38.9968 34.7165C38.8543 34.3525 38.9408 33.9387 39.2172 33.6622ZM66.1053 40.0527H58.5098C58.3539 39.0553 57.6898 38.2228 56.7383 37.8504L54.296 36.8948H58.2106C60.1259 36.8948 61.6843 35.3364 61.6843 33.4211V30.8948C61.6843 28.9795 60.1259 27.4211 58.2106 27.4211H17.7895C15.8742 27.4211 14.3158 28.9795 14.3158 30.8948V33.4211C14.3158 35.3364 15.8742 36.8948 17.7895 36.8948H37.8144L39.0501 40.0527H9.89469V24.2632H16.5262C17.0496 24.2632 17.4736 23.8391 17.4736 23.3158V14.4737C17.4736 13.603 18.1818 12.8947 19.0525 12.8947H29.1579C30.0286 12.8947 30.7368 13.603 30.7368 14.4737V23.3158C30.7368 23.8392 31.1608 24.2632 31.6842 24.2632H66.1052L66.1053 40.0527ZM66.1053 22.3685H32.6315V16.6843H62C64.2637 16.6843 66.1053 18.5259 66.1053 20.7896V22.3685Z",
    fill: "url(#paint4_linear_4127_28302)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7368 18.5158C60.2135 18.5158 59.7895 18.9399 59.7895 19.4632V19.5895C59.7895 20.1129 60.2135 20.5368 60.7368 20.5368C61.2602 20.5368 61.6842 20.1129 61.6842 19.5895V19.4632C61.6842 18.9399 61.2602 18.5158 60.7368 18.5158Z",
    fill: "url(#paint5_linear_4127_28302)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.421 31.2106H19.0526C18.5293 31.2106 18.1053 31.6346 18.1053 32.1579C18.1053 32.6813 18.5294 33.1053 19.0526 33.1053H30.421C30.9444 33.1053 31.3683 32.6812 31.3683 32.1579C31.3685 31.6346 30.9444 31.2106 30.421 31.2106Z",
    fill: "url(#paint6_linear_4127_28302)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9473 18.5158C56.424 18.5158 56 18.9399 56 19.4632V19.5895C56 20.1129 56.4241 20.5368 56.9473 20.5368C57.4706 20.5368 57.8947 20.1129 57.8947 19.5895V19.4632C57.8947 18.9399 57.4707 18.5158 56.9473 18.5158Z",
    fill: "url(#paint7_linear_4127_28302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4127_28302",
    x1: 10.2649,
    y1: 9.55465,
    x2: 59.0802,
    y2: 71.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticSlant4);
export default __webpack_public_path__ + "static/media/analytic_slant4.c0f277f997e3e64ac468f9fc98c0dae9.svg";
export { ForwardRef as ReactComponent };